// extracted by mini-css-extract-plugin
export default {"products":"home_products__LXAkR","sort":"home_sort__IzneH"};